import { Reveal } from "@/components/motion/Reveal";

const WORDS = [
  "Intelligent Routing",
  "Sentiment AI",
  "Zero-Wait Support",
  "Global Localization",
  "Predictive Insights",
  "Autonomous Agents",
];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <section className="relative border-y border-[#EEF1F4] bg-[#F5F6F8] py-8 overflow-hidden">
      <Reveal className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 mb-6">
        <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#9CA3AF]">
          The operating system for modern customer engagement
        </p>
      </Reveal>
      <div className="relative flex w-max animate-marquee">
        {row.map((w, i) => (
          <div key={i} className="flex items-center gap-8 px-8">
            <span className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-stroke whitespace-nowrap">
              {w}
            </span>
            <span className="h-2 w-2 rounded-full bg-[#9CA3AF]" />
          </div>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#F5F6F8] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#F5F6F8] to-transparent" />
    </section>
  );
}
